import React from 'react'
import haversine from 'haversine'

export default class Distance extends React.Component {
  render() {
    let { distance } = this.props.there
    try {
      distance = haversine(this.props.here, this.props.there, { unit: 'mile' })
      if (isNaN(distance)) throw Error('NaN')
    } catch (err) {
      // ignore and use server's distance
      distance = this.props.there.distance || null
    }
    return (
      <React.Fragment>
        {parseFloat(distance)
          .toFixed(1)
          .replace(/0+$/, '')
          .replace(/\.$/, '')}{' '}
        mile{parseInt(distance.toString(), 10) === 1 ? '' : 's'} away from{' '}
        {this.props.here.address
          ? this.props.here.address
          : this.props.here.zipCode}
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DataView/Distance.js